import { useState } from "react";
import { useNavigate, createSearchParams } from "react-router-dom";
import * as EmailValidator from "email-validator";
import { UsernameCreds } from "../constants/constants";

export const useUsernameRegister = () => {
  const navigate = useNavigate();
  const uppercaseRule = /[A-Z]/;
  const numberRule = /[0-9]/;

  const [showModal, setShowModal] = useState(false);
  const [state, setState] = useState({
    fullName: "",
    fullNameStatus: "normal",
    fullNameErrorMessage: "",
    userName: "",
    userNameStatus: "normal",
    userNameErrorMessage: "",
    email: "",
    emailStatus: "normal",
    emailErrorMessage: "",
    password: "",
    passwordStatus: "normal",
    passwordErrorMessage: "",
    confirmPassword: "",
    confirmPasswordStatus: "normal",
    confirmPasswordErrorMessage: "",
  });

  const handleForms = (field) => (e) => {
    setState({
      ...state,
      [field]: e.target.value,
    });
  };

  const handleRegister = () => {
    if (!state.fullName || state.fullName.length < 5) {
      setState({
        ...state,
        fullNameStatus: "error",
        fullNameErrorMessage: "Full Name must consist of 5 characters",
      });

      return;
    }

    if (!state.userName || state.userName.length < 5) {
      setState({
        ...state,
        fullNameStatus: "normal",
        fullNameErrorMessage: "",
        userNameStatus: "error",
        userNameErrorMessage: "Username must consist of 5 characters",
      });

      return;
    }

    if (!state.userName || !state.userName === UsernameCreds.username) {
      setState({
        ...state,
        fullNameStatus: "normal",
        fullNameErrorMessage: "",
        userNameStatus: "error",
        userNameErrorMessage: "Username exists, please type another username",
      });

      return;
    }

    if (!EmailValidator.validate(state.email)) {
      setState({
        ...state,
        fullNameStatus: "normal",
        fullNameErrorMessage: "",
        userNameStatus: "normal",
        userNameErrorMessage: "",
        emailStatus: "error",
        emailErrorMessage:
          "Invalid email format, use @domain.com for email address",
      });

      return;
    }

    if (!state.password) {
      setState({
        ...state,
        fullNameStatus: "normal",
        fullNameErrorMessage: "",
        userNameStatus: "normal",
        userNameErrorMessage: "",
        emailStatus: "normal",
        emailErrorMessage: "",
        passwordStatus: "error",
        passwordErrorMessage: "Field is required",
      });

      return;
    }

    if (state.password.length < 8) {
      setState({
        ...state,
        fullNameStatus: "normal",
        fullNameErrorMessage: "",
        userNameStatus: "normal",
        userNameErrorMessage: "",
        emailStatus: "normal",
        emailErrorMessage: "",
        passwordStatus: "error",
        passwordErrorMessage: "Password should have at least 8 characters",
      });

      return;
    }

    if (!uppercaseRule.test(state.password)) {
      setState({
        ...state,
        fullNameStatus: "normal",
        fullNameErrorMessage: "",
        userNameStatus: "normal",
        userNameErrorMessage: "",
        emailStatus: "normal",
        emailErrorMessage: "",
        passwordStatus: "error",
        passwordErrorMessage:
          "Password should have at least one uppercase character",
      });

      return;
    }

    if (!numberRule.test(state.password)) {
      setState({
        ...state,
        fullNameStatus: "normal",
        fullNameErrorMessage: "",
        userNameStatus: "normal",
        userNameErrorMessage: "",
        emailStatus: "normal",
        emailErrorMessage: "",
        passwordStatus: "error",
        passwordErrorMessage: "Password should have at least one number",
      });

      return;
    }

    if (state.password !== state.confirmPassword) {
      setState({
        ...state,
        fullNameStatus: "normal",
        fullNameErrorMessage: "",
        userNameStatus: "normal",
        userNameErrorMessage: "",
        emailStatus: "normal",
        emailErrorMessage: "",
        passwordStatus: "normal",
        passwordErrorMessage: "",
        confirmPasswordStatus: "error",
        confirmPasswordErrorMessage:
          "Confirm password does not match with password field",
      });

      return;
    }

    setState({
      ...state,
      passwordStatus: "normal",
      passwordErrorMessage: "",
    });

    setShowModal(true);
  };

  const handleBackToSignIn = () => {
    navigate("/login/username");
  };

  return {
    showModal,
    setShowModal,
    state,
    handleForms,
    handleRegister,
    handleBackToSignIn,
  };
};
